import { observer } from "mobx-react";
import type { default as p5 } from "p5";
import React from "react";

import { PerformanceState } from "../../common";
import styles from "./StageBackground.module.css";

export interface StageBackgroundProps {
    performanceState: PerformanceState;
}

@observer
export default class StageBackground extends React.PureComponent<StageBackgroundProps> {
    private el?: HTMLDivElement | null;
    private handleRef = (el: HTMLDivElement | null) => (this.el = el);

    public async componentDidMount() {
        if (typeof window !== "undefined" && this.el != null) {
            const p5ctr = (await import("p5")).default;
            // @ts-ignore
            const instance = new p5ctr((p: p5) => {
                sketch(p, this.props.performanceState);
            }, this.el);
        }
    }

    public render() {
        return <div className={styles.container} ref={this.handleRef} />;
    }
}

/** performance is an observable */
function sketch(p: p5, performance: PerformanceState) {
    let discoShader: p5.Shader | undefined;
    let wavyShader: p5.Shader | undefined;

    p.preload = () => {
        discoShader = p.loadShader("/shaders/disco.vert", "/shaders/disco.frag");
        wavyShader = p.loadShader("/shaders/disco.vert", "/shaders/wavy.frag");
    };

    p.setup = () => {
        p.pixelDensity(1);
        p.setAttributes("antialias", true);

        // shaders require WEBGL mode to work
        const canvas = p.createCanvas(p.windowWidth, p.windowHeight, p.WEBGL);
        canvas.position(0, 0);
    };

    p.draw = () => {
        const background = performance.scenePrompts.get(performance.scene)?.stageBackground;

        if (background == null) {
            p.clear();
            return;
        }

        const shader = background === "disco" ? discoShader : wavyShader;
        if (shader === undefined) {
            return;
        }

        // shader() sets the active shader with our shader
        p.shader(shader);

        const width = p.width / 2;
        const height = p.height / 2;

        shader.setUniform("resolution", [width, height]);
        shader.setUniform("time", p.millis() / 1000.0);

        // rect gives us some geometry on the screen
        p.rect(0, 0, p.width, p.height);
    };

    p.windowResized = () => {
        p.resizeCanvas(p.windowWidth, p.windowHeight);
    };
}
